import classNames from "classnames";
import React from "react";
import Tooltip from "./../../wix-rich-content-common/lib/Tooltip";
import {
  VERTICAL_EMBED_BUTTON,
  VERTICAL_EMBED_SUBTITLE,
  VERTICAL_EMBED_TITLE
} from "./../data-hooks";
import styles from "../statics/styles/widget-scss";
const CardContent = (props) => {
  const { title, info, buttonText, disabled, t } = props;
  return /* @__PURE__ */ React.createElement("div", { className: styles.content }, /* @__PURE__ */ React.createElement("div", { className: styles.contentText }, /* @__PURE__ */ React.createElement("div", { className: styles.title, "data-hook": VERTICAL_EMBED_TITLE }, ellipsisTitle(title)), info && /* @__PURE__ */ React.createElement(Subtitle, { info })), /* @__PURE__ */ React.createElement(Tooltip, { content: disabled ? t("VerticalEmbed_Disabled_Button_Tooltip") : null }, /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-hook": VERTICAL_EMBED_BUTTON,
      className: classNames(styles.button, { [styles.button_disabled]: disabled })
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.buttonText }, buttonText)
  )));
};
const Subtitle = ({ info }) => {
  return info.leftSubtitle ? /* @__PURE__ */ React.createElement("div", { className: styles.subtitle, "data-hook": VERTICAL_EMBED_SUBTITLE }, info.leftSubtitle, info.rightSubtitle && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: styles.right }, "|"), info.rightSubtitle)) : null;
};
const ellipsisTitle = (title) => {
  return title.length <= 80 ? title : `${title.substring(0, 80)}...`;
};
export {
  CardContent
};
//# sourceMappingURL=CardContent.js.map
